import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderProgramsRoutingModule } from './header-programs-routing.module';
import { GraduateComponent } from './graduate/graduate.component';
import { PostGraduateComponent } from './post-graduate/post-graduate.component';
import { DoctoralComponent } from './doctoral/doctoral.component';
import { DiplomaComponent } from './diploma/diploma.component';
import { IntegratedComponent } from './integrated/integrated.component';
import { CertificateComponent } from './certificate/certificate.component';


@NgModule({
  declarations: [
    GraduateComponent,
    PostGraduateComponent,
    DoctoralComponent,
    DiplomaComponent,
    IntegratedComponent,
    CertificateComponent
  ],
  imports: [
    CommonModule,
    HeaderProgramsRoutingModule
  ]
})
export class HeaderProgramsModule { }
